module.exports = __webpack_public_path__ + "static/1-Tri-02-b49d7af8446baf9a49e515ca78fa6772.png";